import {
  siYoutube,
  siSoundcloud,
  siBandcamp,
  siMixcloud,
  siTwitch,
  siX,
  siInstagram,
  siFacebook,
  siReddit,
  siTumblr,
  siLinktree,
} from 'simple-icons';
import type { SimpleIcon } from 'simple-icons';

/** brand slug -> official Simple Icon (authoritative path + brand hex) */
const ICONS: Record<string, SimpleIcon> = {
  youtube: siYoutube,
  soundcloud: siSoundcloud,
  bandcamp: siBandcamp,
  mixcloud: siMixcloud,
  twitch: siTwitch,
  x: siX,
  instagram: siInstagram,
  facebook: siFacebook,
  reddit: siReddit,
  tumblr: siTumblr,
  linktree: siLinktree,
};

/** Official brand color for a slug's squircle tile (e.g. "#FF0000").
   Email isn't a brand — it gets the "active" blue accent. */
export function brandHex(slug: string): string {
  if (slug === 'email') return '#5b8def';
  const icon = ICONS[slug];
  return icon ? `#${icon.hex}` : '#333333';
}

/** White glyph, sized to sit centered on a colored squircle tile. */
export function PlatformIcon({ slug }: { slug: string }) {
  if (slug === 'email') {
    return (
      <svg viewBox="0 0 24 24" role="img" aria-label="Email" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="5" width="18" height="14" rx="2.5" />
        <path d="M4 7l8 6 8-6" />
      </svg>
    );
  }
  const icon = ICONS[slug];
  if (!icon) return null;
  return (
    <svg viewBox="0 0 24 24" role="img" aria-label={icon.title} fill="#ffffff">
      <path d={icon.path} />
    </svg>
  );
}
